// src/pages/AyarlarPage.js
import React, { useState, useMemo, useEffect } from "react";
import ResimUpload from "../ResimUpload";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "../config";

/* --- UI DİLİ SÖZLÜĞÜ --- */
const t = {
  tr: { settings:"Ayarlar", uiLanguage:"Arayüz Dili", contentLanguage:"İçerik Dilleri",
    firmName:"Kurum / Firma Adı", slogan:"Slogan", branch:"Mahalle / Şube Adı",
    authorized:"Yetkili Adı", authorizedEditable:"Yetkili Adı (Düzenle)", city:"İl", district:"İlçe",
    phone:"Telefon", email:"E-Posta", website:"Web Sitesi", logoUpload:"Logo Yükle",
    theme:"Tema", light:"Açık Tema", dark:"Koyu Tema", social:"Sosyal Medya",
    facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)", linkedin:"LinkedIn",
 menuManager: "🛠️ Menü Yönetimi",
    addCategory: "➕ Kategori Ekle",
    categoryPlaceholder: "Kategori adı (Örn: Çorbalar)",
    productImage: "Ürün Görseli",
    productName: "Ürün adı",
    productDesc: "Ürün açıklaması",
    price: "Fiyat",
    addProduct: "➕ Ürün / Hizmet Ekle",
    edit: "Düzenle",
    saveInline: "💾 Kaydet",
    delete: "Sil",
    productCount: "ürün",
currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Laktoz",
  peanut: "Fıstık",
  egg: "Yumurta",
  soy: "Soya",
},
passwordChangeTitle: "🔐 Şifre Değiştir",
passwordChangeDesc: "Mevcut şifrenizi girerek yeni şifre belirleyin",
currentPassword: "Mevcut şifre",
newPassword: "Yeni şifre",
newPasswordRepeat: "Yeni şifre (tekrar)",
updatePassword: "Şifreyi Güncelle",
passwordUpdated: "✅ Şifre başarıyla güncellendi",
fillAllFields: "Lütfen tüm alanları doldurun",
passwordsNotMatch: "Yeni şifreler uyuşmuyor",
passwordMin: "Yeni şifre en az 6 karakter olmalı",
sessionNotFound: "Oturum bulunamadı",
passwordUpdateFail: "Şifre değiştirilemedi",
downloadsTitle: "Dosya & Link Paylaşımları",
downloadAdd: "Yeni Dosya / Link Ekle",
downloadEdit: "Dosya / Link Güncelle",
uploadFile: "Dosya Yükle",
noDownloads: "Henüz eklenmiş dosya / link yok.",
file: "Dosya",
title: "Başlık",
description: "Açıklama",
add: "Ekle",
update: "Güncelle",
unnamed: "Başlıksız",
link: "Link",
menuLangTitle: "🌍 Menü Dil Seçimi",
menuLangDesc: "Menü web sayfasında hangi dillerde görünsün?",
trendProduct: "⭐ Trend Ürün",
beautyTitle: "Kuaför / Güzellik Salonu",
beautyEnable: "Kuaför / Güzellik Salonu Modülünü Aktif Et",
beautyDesc: "Hizmet kataloğu, fiyat listesi, sıkça sorulan sorular ve randevu talepleri",

orderTitle: "Sipariş Takibi",
orderEnable: "Sipariş Sistemini Aktif Et",
orderDesc: "QR Menü, restoran, kafe siparişlerini yönet",

memorialTitle: "QR Mezarlık / Dijital Anıt",
memorialEnable: "QR Mezarlık Modülünü Aktif Et",
memorialDesc: "Dijital anıt, biyografi, fotoğraf, video, dua ve QR sayfası yönetimi",

bookingTitle: "Randevu Sistemi",
bookingEnable: "Randevu Sistemini Aktif Et",
bookingDesc: "Doktor, restoran, hizmet randevuları",

accountingTitle: "Muhasebe / Vergi / Sigorta",
accountingEnable: "Muhasebe ve Vergi Süreçlerini Aktif Et",
accountingDesc: "Evrak toplama, vergi beyanı ve sigorta işlemleri",




categorySelect: "Kategori seç",
marketplaceVisibility: "Kurum Kullanıcı Görünürlüğü",
marketplaceVisibilityDesc: "Kullanıcılar hangi kurumları görebilsin?",
marketplaceAll: "Tüm kurumlar",
marketplaceOwnSector: "Kendi sektörüm Dışındakiler",
marketplaceNone: "Hiçbir kurumu gösterme",
    youtube:"YouTube", save:"Kaydet", success:"✅ Ayarlar Kaydedildi", fail:"❌ Kayıt başarısız oldu.",
menuSettings: "Menü / Hizmet Ayarları",
  menuEnableTitle: "Menü / Fiyat Listesi",
    menuEnableDesc: "Kafe, restoran, yol yardımı, hizmet listesi vb.",
    allergenTitle: "Alerji Bilgileri",
    allergenDesc: "Gluten, laktoz, fıstık vb.",
    serverError:"❌ Sunucu hatası." },
  en: { settings:"Settings", uiLanguage:"UI Language", contentLanguage:"Content Languages",
    firmName:"Organization / Company Name", slogan:"Slogan", branch:"Neighborhood / Branch Name",
    authorized:"Authorized Person", authorizedEditable:"Authorized (Editable)", city:"City", district:"District",
    phone:"Phone", email:"Email", website:"Website", logoUpload:"Upload Logo",
    theme:"Theme", light:"Light Theme", dark:"Dark Theme", social:"Social Media",
    facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)", linkedin:"LinkedIn",
  menuManager: "🛠️ Menu Management",
    addCategory: "➕ Add Category",
    categoryPlaceholder: "Category name (e.g. Soups)",
    productImage: "Product Image",
    productName: "Product name",
    productDesc: "Product description",
    price: "Price",
    addProduct: "➕ Add Product / Service",
    edit: " Edit",
    saveInline: "💾 Save",
    delete: "Delete",
    productCount: "items",
downloadsTitle: "Files & Links",
downloadAdd: "Add File / Link",
downloadEdit: "Edit File / Link",
uploadFile: "Upload File",
noDownloads: "No files or links added yet.",
file: "File",
link: "Link",
title: "Title",
description: "Description",
add: "Add",
update: "Update",
unnamed: "Untitled",
categorySelect: "Select category",

beautyTitle: "Hairdresser / Beauty Salon",
beautyEnable: "Enable Beauty Salon Module",
beautyDesc: "Manage service catalog, price list, FAQ and appointment requests",

orderTitle: "Order Tracking",
orderEnable: "Enable Order System",
orderDesc: "Manage QR menu, restaurant and cafe orders",

memorialTitle: "QR Cemetery / Digital Memorial",
memorialEnable: "Enable QR Cemetery Module",
memorialDesc: "Manage digital memorial, biography, photos, videos, prayers and QR page",

bookingTitle: "Appointment System",
bookingEnable: "Enable Appointment System",
bookingDesc: "Doctor, restaurant and service appointments",

accountingTitle: "Accounting / Tax / Insurance",
accountingEnable: "Enable Accounting and Tax Processes",
accountingDesc: "Document collection, tax declaration and insurance processes",


currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Lactose",
  peanut: "Peanuts",
  egg: "Egg",
  soy: "Soy",
},
passwordChangeTitle: "🔐 Change Password",
passwordChangeDesc: "Set a new password by entering your current password",
currentPassword: "Current password",
newPassword: "New password",
newPasswordRepeat: "New password (repeat)",
updatePassword: "Update Password",
passwordUpdated: "✅ Password updated successfully",
fillAllFields: "Please fill in all fields",
passwordsNotMatch: "Passwords do not match",
passwordMin: "Password must be at least 6 characters",
sessionNotFound: "Session not found",
passwordUpdateFail: "Password could not be updated",
menuLangTitle: "🌍 Menu Language Selection",
menuLangDesc: "In which languages should the menu appear on the website?",
 youtube:"YouTube", save:"Save", success:"✅ Settings Saved", fail:"❌ Save failed.",
trendProduct: "⭐ Trending Product",
marketplaceVisibility: "Marketplace Visibility",
marketplaceVisibilityDesc: "Which institutions can users see?",
marketplaceAll: "All institutions",
marketplaceOwnSector: "Other sectors",
marketplaceNone: "Show no institutions",



  menuSettings: "Menu / Service Settings",
    menuEnableTitle: "Menu / Price List",
    menuEnableDesc: "Cafe, restaurant, service list, etc.",
    allergenTitle: "Allergen Information",
    allergenDesc: "Gluten, lactose, peanuts, etc.",
    serverError:"❌ Server error." },




  de: { settings:"Einstellungen", uiLanguage:"UI-Sprache", contentLanguage:"Inhaltssprachen",
    firmName:"Organisation / Firmenname", slogan:"Slogan", branch:"Stadtteil / Filiale",
    authorized:"Verantwortliche Person", authorizedEditable:"Verantwortliche (bearbeitbar)",
    city:"Stadt", district:"Bezirk", phone:"Telefon", email:"E-Mail", website:"Webseite",
    logoUpload:"Logo hochladen", theme:"Theme", light:"Helles Theme", dark:"Dunkles Theme",
    social:"Soziale Medien", facebook:"Facebook", instagram:"Instagram", twitter:"Twitter (X)",
    linkedin:"LinkedIn", youtube:"YouTube", save:"Speichern", success:"✅ Einstellungen Gespeichert",
   menuManager: "🛠️ Menüverwaltung",
    addCategory: "➕ Kategorie hinzufügen",
    categoryPlaceholder: "Kategoriename (z. B. Suppen)",
    productImage: "Produktbild",
    productName: "Produktname",
    productDesc: "Produktbeschreibung",
    price: "Preis",
    addProduct: "➕ Produkt / Dienst hinzufügen",
    edit: "Bearbeiten",
    saveInline: "💾 Speichern",
    delete: "Löschen",
    productCount: "Produkte",
downloadsTitle: "Dateien & Links",
downloadAdd: "Datei / Link hinzufügen",
downloadEdit: "Datei / Link bearbeiten",
uploadFile: "Datei hochladen",
noDownloads: "Noch keine Dateien oder Links vorhanden.",
file: "Datei",
link: "Link",
menuLangTitle: "🌍 Menü-Sprachauswahl",
menuLangDesc: "In welchen Sprachen soll das Menü auf der Website angezeigt werden?",



title: "Titel",
description: "Beschreibung",
add: "Hinzufügen",
update: "Aktualisieren",
unnamed: "Ohne Titel",
categorySelect: "Kategorie auswählen",
marketplaceVisibility: "Marktplatz-Sichtbarkeit",
marketplaceVisibilityDesc: "Welche Institutionen können Benutzer sehen?",
marketplaceAll: "Alle Institutionen",
marketplaceOwnSector: "Andere Branchen",
marketplaceNone: "Keine Institutionen anzeigen",


currencyTRY: "₺ TRY",
currencyUSD: "$ USD",
currencyEUR: "€ EUR",
currencyCHF: "CHF",
allergens: {
  gluten: "Gluten",
  lactose: "Laktose",
  peanut: "Erdnüsse",
  egg: "Ei",
  soy: "Soja",
},
passwordChangeTitle: "🔐 Passwort ändern",
passwordChangeDesc: "Legen Sie ein neues Passwort mit Ihrem aktuellen Passwort fest",
currentPassword: "Aktuelles Passwort",
newPassword: "Neues Passwort",
newPasswordRepeat: "Neues Passwort (wiederholen)",
updatePassword: "Passwort aktualisieren",
passwordUpdated: "✅ Passwort erfolgreich aktualisiert",
fillAllFields: "Bitte alle Felder ausfüllen",
passwordsNotMatch: "Passwörter stimmen nicht überein",
passwordMin: "Passwort muss mindestens 6 Zeichen lang sein",
sessionNotFound: "Sitzung nicht gefunden",
passwordUpdateFail: "Passwort konnte nicht geändert werden",

    menuSettings: "Menü- / Serviceeinstellungen",
    menuEnableTitle: "Menü / Preisliste",
    menuEnableDesc: "Café, Restaurant, Serviceliste usw.",
    allergenTitle: "Allergeninformationen",
    allergenDesc: "Gluten, Laktose, Erdnüsse usw.",
trendProduct: "⭐ Trendprodukt",
beautyTitle: "Friseur / Schönheitssalon",
beautyEnable: "Schönheitssalon-Modul aktivieren",
beautyDesc: "Dienstleistungskatalog, Preisliste, FAQ und Terminanfragen verwalten",


orderTitle: "Bestellverwaltung",
orderEnable: "Bestellsystem aktivieren",
orderDesc: "QR-Menü, Restaurant- und Café-Bestellungen verwalten",

memorialTitle: "QR-Friedhof / Digitales Denkmal",
memorialEnable: "QR-Friedhof-Modul aktivieren",
memorialDesc: "Digitales Denkmal, Biografie, Fotos, Videos, Gebete und QR-Seite verwalten",

bookingTitle: "Terminsystem",
bookingEnable: "Terminsystem aktivieren",
bookingDesc: "Termine für Ärzte, Restaurants und Dienstleistungen",

accountingTitle: "Buchhaltung / Steuern / Versicherung",
accountingEnable: "Buchhaltungs- und Steuerprozesse aktivieren",
accountingDesc: "Dokumentensammlung, Steuererklärung und Versicherungsprozesse",


    fail:"❌ Speichern fehlgeschlagen.", serverError:"❌ Serverfehler." },

};

/* ✅ ALLERGEN SABİTLERİ — BURAYA */
const ALLERGEN_KEYS = ["gluten", "lactose", "peanut", "egg", "soy"];

/* ===========================================================
   🔐 KULLANICI & YETKİ YÖNETİMİ — GELECEĞE HAZIR ÖN PANEL
   Not:
   - Bu blok frontend yönetim panelini hazırlar.
   - Gerçek güvenlik için backend login + token + API permission kontrolü gerekir.
   - Şifreler ayarlar JSON’una düz metin kaydedilmez.
   =========================================================== */

const AUTH_PERMISSION_GROUPS = [
  {
    title: "Dashboard & Ana Panel",
    desc: "Kullanıcı paneli açtığında göreceği ana ekran ve genel kartlar",
    items: [
      { key: "dashboard.view", label: "Dashboard / Ana ekranı görsün" },
      { key: "dashboard.stats", label: "Dashboard istatistik kartlarını görsün" },
      { key: "dashboard.quick_actions", label: "Hızlı işlem butonlarını görsün" },
      { key: "reports.view", label: "Genel raporları görsün" },
      { key: "reports.export", label: "Rapor CSV / PDF dışa aktarabilsin" },
    ],
  },

  {
    title: "Kurum & Genel Ayarlar",
    desc: "Firma bilgileri, logo, dil, tema, sosyal medya ve genel panel ayarları",
    items: [
      { key: "settings.view", label: "Ayarlar ekranını görsün" },
      { key: "settings.manage", label: "Genel ayarları değiştirsin" },
      { key: "company.info.manage", label: "Firma bilgilerini düzenlesin" },
      { key: "company.logo.manage", label: "Logo yüklesin / değiştirsin" },
      { key: "company.languages.manage", label: "Panel ve içerik dillerini yönetsin" },
      { key: "company.theme.manage", label: "Tema / görünüm ayarlarını değiştirsin" },
      { key: "users.manage", label: "Kullanıcı ve yetki yönetsin" },
    ],
  },

  {
    title: "QR Menü & Menü Yönetimi",
    desc: "QR menü, ana kategoriler, alt kategoriler, ürünler ve fiyat düzenleme",
    items: [
      { key: "menu.view", label: "QR menüyü görsün" },
      { key: "menu.manage", label: "QR menüyü düzenlesin" },
      { key: "menu.settings.view", label: "Menü ayarlarını görsün" },
      { key: "menu.settings.manage", label: "Menü ayarlarını değiştirsin" },

      { key: "menu.main_categories.view", label: "Ana kategorileri görsün" },
      { key: "menu.main_categories.manage", label: "Ana kategori eklesin / düzenlesin / silsin" },

      { key: "menu.categories.view", label: "Alt kategorileri görsün" },
      { key: "menu.categories.manage", label: "Alt kategori eklesin / düzenlesin / silsin" },

      { key: "menu.products.view", label: "Ürünleri görsün" },
      { key: "menu.products.manage", label: "Ürün eklesin / düzenlesin / silsin" },
      { key: "menu.prices.manage", label: "Ürün fiyatlarını değiştirsin" },
      { key: "menu.images.manage", label: "Ürün görsellerini değiştirsin" },
      { key: "menu.trend.manage", label: "Trend ürünleri yönetsin" },
      { key: "menu.allergens.manage", label: "Alerjen bilgilerini yönetsin" },
      { key: "menu.languages.manage", label: "Menü dillerini yönetsin" },
    ],
  },

  {
    title: "Sipariş & Garson Çağırma",
    desc: "QR sipariş, masa takibi, sipariş durumu ve garson çağırma ekranları",
    items: [
      { key: "orders.view", label: "Siparişleri görsün" },
      { key: "orders.create", label: "Sipariş oluşturabilsin" },
      { key: "orders.manage", label: "Sipariş durumunu değiştirsin" },
      { key: "orders.delete", label: "Sipariş silebilsin" },
      { key: "orders.print", label: "Sipariş yazdırabilsin" },

      { key: "tables.view", label: "Masa ekranını görsün" },
      { key: "tables.manage", label: "Masa işlemlerini yönetsin" },

      { key: "waiter_call.view", label: "Garson çağrılarını görsün" },
      { key: "waiter_call.manage", label: "Garson çağrılarını kapatsın / yönetsin" },
    ],
  },

  {
    title: "Kasa & Tahsilat",
    desc: "Kasa hareketleri, gelir-gider, ödeme ve tahsilat işlemleri",
    items: [
      { key: "cash.view", label: "Kasayı görsün" },
      { key: "cash.create", label: "Kasaya işlem eklesin" },
      { key: "cash.manage", label: "Kasa işlemlerini düzenlesin" },
      { key: "cash.delete", label: "Kasa işlemi silebilsin" },
      { key: "cash.reports.view", label: "Kasa raporlarını görsün" },
      { key: "cash.export", label: "Kasa raporlarını dışa aktarabilsin" },
    ],
  },

  {
    title: "Cari & Müşteri Hesapları",
    desc: "Cari hesap, müşteri borç/alacak, tahsilat geçmişi ve kişi hareketleri",
    items: [
      { key: "current.view", label: "Cari hesapları görsün" },
      { key: "current.create", label: "Cari kişi/firma eklesin" },
      { key: "current.manage", label: "Cari kayıtları düzenlesin" },
      { key: "current.delete", label: "Cari kayıt silebilsin" },
      { key: "current.payments.view", label: "Tahsilat geçmişini görsün" },
      { key: "current.payments.manage", label: "Tahsilat eklesin / düzenlesin" },
      { key: "current.reports.view", label: "Cari raporları görsün" },
    ],
  },

  {
    title: "Stok Yönetimi",
    desc: "Stok kartları, stok girişi, stok çıkışı, sayım, kritik stok ve raporlar",
    items: [
      { key: "stock.view", label: "Stok ana ekranını görsün" },
      { key: "stock.cards.view", label: "Stok kartlarını görsün" },
      { key: "stock.cards.manage", label: "Stok kartı eklesin / düzenlesin / silsin" },
      { key: "stock.entry.manage", label: "Stok girişi yapabilsin" },
      { key: "stock.out.manage", label: "Stok çıkışı yapabilsin" },
      { key: "stock.count.manage", label: "Stok sayımı yapabilsin" },
      { key: "stock.critical.view", label: "Kritik stokları görsün" },
      { key: "stock.movements.view", label: "Stok hareketlerini görsün" },
      { key: "stock.reports.view", label: "Stok raporlarını görsün" },
      { key: "stock.settings.manage", label: "Stok ayarlarını değiştirsin" },
    ],
  },

  {
    title: "Duyurular & Etkinlikler",
    desc: "Kurum duyuruları, etkinlikler, haberler ve içerik yayınlama ekranları",
    items: [
      { key: "announcements.view", label: "Duyuruları görsün" },
      { key: "announcements.manage", label: "Duyuru eklesin / düzenlesin / silsin" },

      { key: "events.view", label: "Etkinlikleri görsün" },
      { key: "events.manage", label: "Etkinlik eklesin / düzenlesin / silsin" },

      { key: "news.view", label: "Haber / içerik bölümünü görsün" },
      { key: "news.manage", label: "Haber / içerik eklesin / düzenlesin / silsin" },
    ],
  },

  {
    title: "Anketler & Formlar",
    desc: "Anket, form, başvuru ve müşteri geri bildirim ekranları",
    items: [
      { key: "surveys.view", label: "Anketleri görsün" },
      { key: "surveys.manage", label: "Anket eklesin / düzenlesin / silsin" },
      { key: "forms.view", label: "Formları / başvuruları görsün" },
      { key: "forms.manage", label: "Form ve başvuru işlemlerini yönetsin" },
      { key: "feedback.view", label: "Müşteri geri bildirimlerini görsün" },
      { key: "feedback.manage", label: "Geri bildirimleri yönetsin" },
    ],
  },

  {
    title: "Dosya & Link Paylaşımları",
    desc: "PDF, belge, link, katalog ve kullanıcıya gösterilecek paylaşım alanları",
    items: [
      { key: "files.view", label: "Dosya / link paylaşımlarını görsün" },
      { key: "files.manage", label: "Dosya / link eklesin / düzenlesin / silsin" },
      { key: "files.download", label: "Dosya indirebilsin" },
    ],
  },

  {
    title: "Randevu Sistemi",
    desc: "Randevu takibi, randevu türleri, müşteri randevuları ve takvim yönetimi",
    items: [
      { key: "appointments.view", label: "Randevuları görsün" },
      { key: "appointments.create", label: "Randevu oluşturabilsin" },
      { key: "appointments.manage", label: "Randevu düzenlesin / iptal etsin" },
      { key: "appointments.calendar.view", label: "Takvim görünümünü görsün" },
      { key: "appointments.settings.manage", label: "Randevu ayarlarını değiştirsin" },
    ],
  },

  {
    title: "Beauty / Kuaför & Güzellik",
    desc: "Güzellik merkezi müşterileri, seanslar, paketler, hizmetler ve tahsilatlar",
    items: [
      { key: "beauty.view", label: "Beauty ana ekranını görsün" },
      { key: "beauty.customers.view", label: "Beauty müşterilerini görsün" },
      { key: "beauty.customers.manage", label: "Beauty müşteri eklesin / düzenlesin" },
      { key: "beauty.services.view", label: "Hizmetleri görsün" },
      { key: "beauty.services.manage", label: "Hizmet eklesin / düzenlesin" },
      { key: "beauty.packages.view", label: "Paketleri görsün" },
      { key: "beauty.packages.manage", label: "Paket eklesin / düzenlesin" },
      { key: "beauty.sessions.view", label: "Seansları görsün" },
      { key: "beauty.sessions.manage", label: "Seans eklesin / düzenlesin" },
      { key: "beauty.payments.view", label: "Beauty tahsilatlarını görsün" },
      { key: "beauty.payments.manage", label: "Beauty tahsilatı eklesin / düzenlesin" },
      { key: "beauty.reports.view", label: "Beauty raporlarını görsün" },
    ],
  },

  {
    title: "Mesaj Merkezi",
    desc: "WhatsApp, e-posta, SMS, otomatik hatırlatma ve mesaj şablonları",
    items: [
      { key: "messages.view", label: "Mesaj merkezini görsün" },
      { key: "messages.send", label: "Mesaj gönderebilsin" },
      { key: "messages.templates.view", label: "Mesaj şablonlarını görsün" },
      { key: "messages.templates.manage", label: "Mesaj şablonu eklesin / düzenlesin" },
      { key: "messages.automation.view", label: "Otomatik mesaj kurallarını görsün" },
      { key: "messages.automation.manage", label: "Otomatik mesaj kurallarını yönetsin" },
      { key: "messages.logs.view", label: "Mesaj loglarını görsün" },
    ],
  },

  {
    title: "Dijital İmza & Evrak",
    desc: "PDF evrak, dijital imza gönderimi, imza takibi ve evrak arşivi",
    items: [
      { key: "digital_signature.view", label: "Dijital imza ekranını görsün" },
      { key: "digital_signature.create", label: "İmzaya evrak gönderebilsin" },
      { key: "digital_signature.manage", label: "Dijital imza işlemlerini yönetsin" },
      { key: "digital_signature.archive.view", label: "İmzalı evrak arşivini görsün" },
      { key: "digital_signature.settings.manage", label: "Dijital imza ayarlarını değiştirsin" },
    ],
  },

  {
    title: "QR Mezarlık / Dijital Anıt",
    desc: "Dijital anıt, biyografi, fotoğraf, video, dua ve taziye yönetimi",
    items: [
      { key: "memorial.view", label: "QR Mezarlık modülünü görsün" },
      { key: "memorial.records.view", label: "Anıt kayıtlarını görsün" },
      { key: "memorial.records.manage", label: "Anıt kaydı eklesin / düzenlesin" },
      { key: "memorial.gallery.manage", label: "Fotoğraf / video galerisi yönetsin" },
      { key: "memorial.condolences.view", label: "Taziye mesajlarını görsün" },
      { key: "memorial.condolences.manage", label: "Taziye mesajlarını yönetsin" },
      { key: "memorial.settings.manage", label: "QR Mezarlık ayarlarını değiştirsin" },
    ],
  },

  {
    title: "Marketplace / Pazar Yeri",
    desc: "Kurum görünürlüğü, pazar yeri listesi, firma kartları ve ilan yönetimi",
    items: [
      { key: "marketplace.view", label: "Pazar yerini görsün" },
      { key: "marketplace.visibility.manage", label: "Pazar yeri görünürlüğünü değiştirsin" },
      { key: "marketplace.profile.manage", label: "Pazar yeri firma profilini düzenlesin" },
      { key: "marketplace.listings.view", label: "Pazar yeri ilanlarını görsün" },
      { key: "marketplace.listings.manage", label: "Pazar yeri ilanı eklesin / düzenlesin" },
    ],
  },

  {
    title: "Şube & Bayilik",
    desc: "Şube seçimi, şube verileri, merkez/şube kapsamı ve bayilik sistemi",
    items: [
      { key: "branches.view", label: "Şubeleri görsün" },
      { key: "branches.manage", label: "Şube eklesin / düzenlesin" },
      { key: "branches.consolidated.view", label: "Konsolide şube raporlarını görsün" },

      { key: "dealers.view", label: "Bayilik sistemini görsün" },
      { key: "dealers.manage", label: "Bayilik kayıtlarını yönetsin" },
      { key: "dealers.commission.view", label: "Hakediş / komisyon bilgilerini görsün" },
      { key: "dealers.commission.manage", label: "Hakediş / komisyon düzenlesin" },
    ],
  },

  {
    title: "Muhasebe / Vergi / Sigorta",
    desc: "Evrak toplama, vergi, sigorta ve muhasebe süreçleri",
    items: [
      { key: "accounting.view", label: "Muhasebe modülünü görsün" },
      { key: "accounting.documents.view", label: "Muhasebe evraklarını görsün" },
      { key: "accounting.documents.manage", label: "Muhasebe evrakı eklesin / düzenlesin" },
      { key: "accounting.tax.view", label: "Vergi süreçlerini görsün" },
      { key: "accounting.tax.manage", label: "Vergi süreçlerini yönetsin" },
      { key: "accounting.insurance.view", label: "Sigorta süreçlerini görsün" },
      { key: "accounting.insurance.manage", label: "Sigorta süreçlerini yönetsin" },
    ],
  },

  {
    title: "Sistem & Kritik İşlemler",
    desc: "Silme, dışa aktarma, destek, log ve gelişmiş sistem yetkileri",
    items: [
      { key: "system.logs.view", label: "İşlem loglarını görsün" },
      { key: "system.support.view", label: "Destek ekranını görsün" },
      { key: "system.delete_allowed", label: "Silme işlemleri yapabilsin" },
      { key: "system.export_allowed", label: "Veri dışa aktarabilsin" },
      { key: "system.admin_tools", label: "Gelişmiş yönetici araçlarını görsün" },
    ],
  },
];
const ALL_PERMISSION_KEYS = AUTH_PERMISSION_GROUPS.flatMap(group =>
  group.items.map(item => item.key)
);

const ROLE_PRESETS = {
  owner: {
    label: "Firma Sahibi / Tam Yetkili",
    desc: "Tüm modülleri, tüm şubeleri ve tüm yönetim ekranlarını görür.",
    permissions: ALL_PERMISSION_KEYS,
  },

  manager: {
    label: "Müdür",
    desc: "Operasyon, sipariş, stok, menü, randevu, rapor ve günlük yönetimi görür.",
    permissions: [
      "dashboard.view",
      "dashboard.stats",
      "dashboard.quick_actions",
      "reports.view",

      "menu.view",
      "menu.manage",
      "menu.main_categories.view",
      "menu.main_categories.manage",
      "menu.categories.view",
      "menu.categories.manage",
      "menu.products.view",
      "menu.products.manage",
      "menu.prices.manage",
      "menu.images.manage",
      "menu.trend.manage",

      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "tables.view",
      "tables.manage",
      "waiter_call.view",
      "waiter_call.manage",

      "stock.view",
      "stock.cards.view",
      "stock.cards.manage",
      "stock.entry.manage",
      "stock.out.manage",
      "stock.count.manage",
      "stock.critical.view",
      "stock.movements.view",
      "stock.reports.view",

      "appointments.view",
      "appointments.create",
      "appointments.manage",
      "appointments.calendar.view",

      "beauty.view",
      "beauty.customers.view",
      "beauty.services.view",
      "beauty.packages.view",
      "beauty.sessions.view",
      "beauty.reports.view",

      "announcements.view",
      "announcements.manage",
      "events.view",
      "events.manage",

      "files.view",
      "files.manage",

      "branches.view",
    ],
  },

  waiter: {
    label: "Garson",
    desc: "Sadece sipariş, masa ve garson çağırma ekranlarını görür.",
    permissions: [
      "dashboard.view",
      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "tables.view",
      "waiter_call.view",
      "waiter_call.manage",
    ],
  },

  cashier: {
    label: "Kasiyer",
    desc: "Sipariş, masa ve kasa/tahsilat işlemlerini görür.",
    permissions: [
      "dashboard.view",
      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "tables.view",
      "tables.manage",
      "waiter_call.view",
      "cash.view",
      "cash.create",
      "cash.manage",
      "current.view",
      "current.payments.view",
      "current.payments.manage",
    ],
  },

  stock_staff: {
    label: "Stok Sorumlusu",
    desc: "Sadece stok kartları, giriş/çıkış, sayım ve kritik stok ekranlarını görür.",
    permissions: [
      "dashboard.view",
      "stock.view",
      "stock.cards.view",
      "stock.cards.manage",
      "stock.entry.manage",
      "stock.out.manage",
      "stock.count.manage",
      "stock.critical.view",
      "stock.movements.view",
      "stock.reports.view",
    ],
  },

  menu_staff: {
    label: "Menü Sorumlusu",
    desc: "Sadece QR menü, kategori, ürün, fiyat ve görsel düzenleme ekranlarını görür.",
    permissions: [
      "dashboard.view",
      "menu.view",
      "menu.manage",
      "menu.settings.view",
      "menu.main_categories.view",
      "menu.main_categories.manage",
      "menu.categories.view",
      "menu.categories.manage",
      "menu.products.view",
      "menu.products.manage",
      "menu.prices.manage",
      "menu.images.manage",
      "menu.trend.manage",
      "menu.allergens.manage",
      "menu.languages.manage",
    ],
  },

  content_staff: {
    label: "İçerik Sorumlusu",
    desc: "Duyuru, etkinlik, haber, dosya/link, anket ve form içeriklerini yönetir.",
    permissions: [
      "dashboard.view",
      "announcements.view",
      "announcements.manage",
      "events.view",
      "events.manage",
      "news.view",
      "news.manage",
      "surveys.view",
      "surveys.manage",
      "forms.view",
      "forms.manage",
      "files.view",
      "files.manage",
    ],
  },

  accounting_staff: {
    label: "Muhasebe / Cari Sorumlusu",
    desc: "Cari, kasa, tahsilat, muhasebe ve rapor tarafını görür.",
    permissions: [
      "dashboard.view",
      "reports.view",
      "reports.export",

      "cash.view",
      "cash.create",
      "cash.manage",
      "cash.reports.view",
      "cash.export",

      "current.view",
      "current.create",
      "current.manage",
      "current.payments.view",
      "current.payments.manage",
      "current.reports.view",

      "accounting.view",
      "accounting.documents.view",
      "accounting.documents.manage",
      "accounting.tax.view",
      "accounting.insurance.view",
    ],
  },

  beauty_staff: {
    label: "Beauty / Kuaför Personeli",
    desc: "Beauty müşterileri, hizmetler, paketler, seanslar ve randevuları görür.",
    permissions: [
      "dashboard.view",
      "appointments.view",
      "appointments.create",
      "appointments.manage",
      "appointments.calendar.view",

      "beauty.view",
      "beauty.customers.view",
      "beauty.customers.manage",
      "beauty.services.view",
      "beauty.packages.view",
      "beauty.sessions.view",
      "beauty.sessions.manage",
    ],
  },

  readonly: {
    label: "Sadece Görüntüleme",
    desc: "Sadece izin verilen ekranları görür, işlem yapamaz.",
    permissions: [
      "dashboard.view",
      "reports.view",
      "orders.view",
    ],
  },

  custom: {
    label: "Özel Rol",
    desc: "Firma sahibi yetkileri tek tek seçer.",
    permissions: [],
  },
};


 

const makePermissionMap = (selectedKeys = []) =>
  ALL_PERMISSION_KEYS.reduce((acc, key) => {
    acc[key] = selectedKeys.includes(key);
    return acc;
  }, {});

const createAuthDraft = () => ({
  id: null,
  name: "",
  username: "",
  password: "",
  role: "waiter",
  active: true,
  branchScope: "all",
  branchName: "",
  notes: "",
  permissions: makePermissionMap(ROLE_PRESETS.waiter.permissions),
});


const LANGS = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];

/* 🔒 SABİT ANA KATEGORİLER – TR / EN / DE */
const CATEGORY_DICT = {
  main_dishes: {
    tr: "Ana Yemekler",
    en: "Main Dishes",
    de: "Hauptgerichte",
  },

  grill: {
    tr: "Izgara Çeşitleri",
    en: "Grilled Dishes",
    de: "Grillgerichte",
  },


doner_kebab: {
  tr: "Döner & Kebap",
  en: "Doner & Kebab",
  de: "Döner & Kebab",
},


  fish: {
    tr: "Balık Çeşitleri",
    en: "Fish Dishes",
    de: "Fischgerichte",
  },




pizza_pasta: {
  tr: "Pizza",
  en: "Pizza",
  de: "Pizza",
},

pasta: {
  tr: "Makarna",
  en: "Pasta",
  de: "Pasta",
},

durum: {
  tr: "Dürüm",
  en: "Wrap",
  de: "Dürüm",
},

  home_food: {
    tr: "Ev Yemekleri",
    en: "Home Style Dishes",
    de: "Hausgemachte Gerichte",
  },

  fast_food: {
    tr: "Fast Food",
    en: "Fast Food",
    de: "Fast Food",
  },


  world_cuisine: {
    tr: "Dünya Mutfağı",
    en: "World Cuisine",
    de: "Internationale Küche",
  },

 chef_special: {
    tr: "Şefin Spesiyali",
    en: "Chef’s Special",
    de: "Empfehlung des Küchenchefs",
  },

  local_food: {
    tr: "Yöresel Lezzetler",
    en: "Local Specialties",
    de: "Regionale Spezialitäten",
  },

 
  vegetarian: {
    tr: "Vejetaryen / Vegan",
    en: "Vegetarian / Vegan",
    de: "Vegetarisch / Vegan",
  },


  gluten_free: {
    tr: "Gluten-Free Seçenekler",
    en: "Gluten-Free Options",
    de: "Glutenfreie Optionen",
  },

 smoothies: {
    tr: "Smoothie & Sağlıklı İçecekler",
    en: "Smoothies & Healthy Drinks",
    de: "Smoothies & Gesunde Getränke",
  },

mezze: {
  tr: "Meze",
  en: "Appetizers",
  de: "Vorspeisen",
},

 sides: {
    tr: "Garnitürler",
    en: "Side Dishes",
    de: "Beilagen",
  },



  soups: {
    tr: "Çorbalar",
    en: "Soups",
    de: "Suppen",
  },

  salads: {
    tr: "Salatalar",
    en: "Salads",
    de: "Salate",
  },


  breakfast: {
    tr: "Kahvaltı",
    en: "Breakfast",
    de: "Frühstück",
  },



 ice_cream: {
  tr: "Dondurmalar",
  en: "Ice Cream",
  de: "Eis",
},

  coffee: {
    tr: "Kahveler",
    en: "Coffee",
    de: "Kaffee",
  },


  hot_drinks: {
    tr: "Sıcak İçecekler",
    en: "Hot Drinks",
    de: "Heiße Getränke",
  },


  cold_drinks: {
    tr: "Soğuk İçecekler",
    en: "Cold Drinks",
    de: "Kalte Getränke",
  },




  alcohol: {
    tr: "Alkollü İçecekler",
    en: "Alcoholic Beverages",
    de: "Alkoholische Getränke",
  },

 


  kids_menu: {
    tr: "Çocuk Menüsü",
    en: "Kids Menu",
    de: "Kindermenü",
  },


  bakery: {
    tr: "Unlu Mamüller",
    en: "Bakery Products",
    de: "Backwaren",
  },

 pastry: {
    tr: "Börek ve Poğaça",
    en: "Pastries",
    de: "Börek & Gebäck",
  },

  desserts: {
    tr: "Tatlılar",
    en: "Desserts",
    de: "Desserts",
  },


hookah: {
  tr: "Nargile",
  en: "Hookah",
  de: "Shisha",
},

 
};



/* ---- AKSENT RENGİ ---- */
const ACCENT = "orange";
const clsActive = () => (ACCENT === "orange" ? "bg-orange-600 text-white" : "bg-blue-600 text-white");
const clsInactive = () => (ACCENT === "orange" ? "bg-white text-orange-700 border-orange-600 hover:bg-orange-50" : "bg-white text-blue-700 border-blue-600 hover:bg-blue-50");

const Segmented = ({ value, onChange }) => (
  <div className="inline-flex rounded-2xl border bg-white shadow-sm overflow-hidden">
    {LANGS.map((l, idx) => {
      const active = value === l.code;
      return (
        <button
          key={l.code}
          type="button"
          onClick={() => onChange(l.code)}
          className={[
            "px-4 py-2 text-base font-semibold transition border",
            active ? clsActive() : clsInactive(),
            idx !== LANGS.length - 1 ? "border-r-0" : "",
          ].join(" ")}
        >
          {l.label}
        </button>
      );
    })}
  </div>
);

/* ===========================================================
   Upload URL normalize (panel → ana domain, http→https, /uploads…)
   =========================================================== */
const ORIGIN = ORIGIN_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const UP_BASE = (UPLOAD_BASE && UPLOAD_BASE.trim()) || "";

// panel.haymestasarim.com → haymestasarim.com
function originWithoutPanel(originStr) {
  try {
    const u = new URL(originStr);
    if (u.hostname.startsWith("panel.")) {
      u.hostname = u.hostname.replace(/^panel\./, "");
      return u.origin;
    }
    return u.origin;
  } catch {
    return originStr;
  }
}

function normalizeUploadUrl(raw) {
  if (!raw) return "";
  let u = String(raw).trim();
  u = u.replace(/^http:\/\//i, "https://");
  if (!/^https?:\/\//i.test(u) && !u.startsWith("/")) {
    u = `/uploads/${u}`;
  }
  const strip = (p) => p.replace(/^\/?(upload|uploads)\//i, "").replace(/^\/+/, "");
  try {
    const abs = new URL(u, ORIGIN);
    const filePart = strip(abs.pathname);
    const chosenOrigin = UP_BASE ? new URL(UP_BASE, ORIGIN).origin : originWithoutPanel(ORIGIN);
    const baseUrl = new URL(UP_BASE || "/uploads", chosenOrigin);
    let basePath = baseUrl.pathname.replace(/\/+$/, "");
    if (!/(\/upload(s)?)$/i.test(basePath)) basePath += "/uploads";
    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return u;
  }
}

/* ===========================================================
   Endpoint keşfi (GET) + düz POST ile kaydetme (Duyurular'la aynı mantık)
   =========================================================== */
const SETTINGS_CANDIDATES = [
  "kurum-ayarlar",
  "kurum-ayar",
  "ayarlar",
  "settings",
];

async function apiGetSettings(token) {
  const order = [localStorage.getItem("app_settings_ep")]
    .filter(Boolean)
    .concat(SETTINGS_CANDIDATES);

  for (const ep of order) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        localStorage.setItem("app_settings_ep", ep);
        return { ep, res };
      }
    } catch (e) {
      // sessiz geç
    }
  }

  // 🔁 fallback
  const ep = SETTINGS_CANDIDATES[0];
  const res = await fetch(`${API_BASE}/${ep}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  return { ep, res };
}

// DÜZ POST JSON — 404 gelirse bir sonrakini dener
async function saveSettingsJson(token, body) {
  const eps = [localStorage.getItem("app_settings_ep")]
    .filter(Boolean)
    .concat(SETTINGS_CANDIDATES);

  for (const ep of eps) {
    try {
      const res = await fetch(`${API_BASE}/${ep}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (res.ok) {
        localStorage.setItem("app_settings_ep", ep);
        return res;
      }
      if (res.status === 404) continue;
    } catch (e) {
      // sessiz geç
    }
  }

  return fetch(`${API_BASE}/${SETTINGS_CANDIDATES[0]}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}





/* ============================== SAYFA ============================== */
export default function AyarlarPage() {

// ================= DOSYA & LINK PAYLAŞIMLARI =================
const [downloads, setDownloads] = useState([]);


const [downloadDraft, setDownloadDraft] = useState({
  title: { tr:"", en:"", de:"" },
  description: { tr:"", en:"", de:"" },
  file: "",
  link: ""
});


const [editingDownloadId, setEditingDownloadId] = useState(null);



// 👇 KATEGORİ AKORDİYON STATE
const [openCategoryId, setOpenCategoryId] = useState(null);

// 🔐 ŞİFRE DEĞİŞTİR STATE
const [openPass, setOpenPass] = useState(false);
const [currentPassword, setCurrentPassword] = useState("");
const [newPassword, setNewPassword] = useState("");
const [newPassword2, setNewPassword2] = useState("");
const [passLoading, setPassLoading] = useState(false);

// 🔐 KULLANICI & YETKİ YÖNETİMİ STATE
const [openAuthorization, setOpenAuthorization] = useState(true);
const [authUsers, setAuthUsers] = useState([]);
const [editingAuthId, setEditingAuthId] = useState(null);
const [authDraft, setAuthDraft] = useState(() => createAuthDraft());

const resetAuthDraft = () => {
  setEditingAuthId(null);
  setAuthDraft(createAuthDraft());
};

const handleAuthRoleChange = (role) => {
  const preset = ROLE_PRESETS[role] || ROLE_PRESETS.custom;

  setAuthDraft(prev => ({
    ...prev,
    role,
    permissions: makePermissionMap(preset.permissions || []),
  }));
};

const toggleAuthPermission = (permissionKey) => {
  setAuthDraft(prev => ({
    ...prev,
    role: "custom",
    permissions: {
      ...makePermissionMap(),
      ...(prev.permissions || {}),
      [permissionKey]: !prev.permissions?.[permissionKey],
    },
  }));
};

const toggleAuthGroup = (group, checked) => {
  setAuthDraft(prev => {
    const nextPermissions = {
      ...makePermissionMap(),
      ...(prev.permissions || {}),
    };

    group.items.forEach(item => {
      nextPermissions[item.key] = checked;
    });

    return {
      ...prev,
      role: "custom",
      permissions: nextPermissions,
    };
  });
};

const toggleAllAuthPermissions = (checked) => {
  setAuthDraft(prev => ({
    ...prev,
    role: checked ? "owner" : "custom",
    permissions: makePermissionMap(checked ? ALL_PERMISSION_KEYS : []),
  }));
};

const handleSaveAuthUser = () => {
  const name = (authDraft.name || "").trim();
  const username = (authDraft.username || "").trim();

  if (!name || !username) {
    alert("Lütfen ad soyad ve kullanıcı adını doldurun.");
    return;
  }

  if (!editingAuthId && !authDraft.password.trim()) {
    alert("Yeni kullanıcı için geçici şifre girin.");
    return;
  }

  const oldUser = authUsers.find(u => u.id === editingAuthId);

  const cleanUser = {
    id: editingAuthId || Date.now(),
    name,
    username,
    role: authDraft.role || "custom",
    active: authDraft.active === true,
    branchScope: authDraft.branchScope || "all",
    branchName: (authDraft.branchName || "").trim(),
    notes: (authDraft.notes || "").trim(),
    permissions: {
      ...makePermissionMap(),
      ...(authDraft.permissions || {}),
    },
    password_set: Boolean(oldUser?.password_set || authDraft.password.trim()),
    updated_at: new Date().toISOString(),
  };

  setAuthUsers(prev => {
    if (editingAuthId) {
      return prev.map(u => u.id === editingAuthId ? cleanUser : u);
    }

    return [cleanUser, ...prev];
  });

  resetAuthDraft();
};

const handleEditAuthUser = (user) => {
  setEditingAuthId(user.id);
  setAuthDraft({
    ...createAuthDraft(),
    ...user,
    password: "",
    permissions: {
      ...makePermissionMap(),
      ...(user.permissions || {}),
    },
  });
};

const handleDeleteAuthUser = (id) => {
  if (!window.confirm("Bu kullanıcıyı listeden kaldırmak istiyor musunuz?")) return;
  setAuthUsers(prev => prev.filter(u => u.id !== id));

  if (editingAuthId === id) {
    resetAuthDraft();
  }
};

// 🔁 KATEGORİ SÜRÜKLE – BIRAK SIRALAMA
const moveCategory = (fromIndex, toIndex) => {
  if (fromIndex === toIndex) return;

  setMenuCategories(prev => {
    const copy = [...prev];
    const [moved] = copy.splice(fromIndex, 1);
    copy.splice(toIndex, 0, moved);
    return copy;
  });
};
// ================= RANDEVU SİSTEMİ =================
const [enableBooking, setEnableBooking] = useState(false);

// ================= PAZAR YERİ GÖRÜNÜRLÜK =================
const [marketplaceVisibility, setMarketplaceVisibility] = useState("all"); // "all", "sector", "none"

// ================= MUHASEBE / VERGİ / SİGORTA =================
const [enableAccounting, setEnableAccounting] = useState(false);

// ================= DİJİTAL İMZA SİSTEMİ =================
const [enableDigitalSignature, setEnableDigitalSignature] = useState(false);


const [enableOrderTracking, setEnableOrderTracking] = useState(false);

// ================= QR MEZARLIK / DİJİTAL ANIT =================
const [enableMemorial, setEnableMemorial] = useState(false);

// ================= KUAFÖR / GÜZELLİK SALONU =================
const [enableBeauty, setEnableBeauty] = useState(false);

// === MENÜ YÖNETİMİ STATE ===

const [menuCategories, setMenuCategories] = useState([]);

const loadMenuFromBackend = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;

  // 1️⃣ Sections
  const secRes = await fetch(`${API_BASE}/extra-sections`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const secJson = await secRes.json();

 // 🔹 Tüm kategorileri TEK SEFER çek
const allCatRes = await fetch(`${API_BASE}/extra-categories`, {
  headers: { Authorization: `Bearer ${token}` }
});
const allCatJson = await allCatRes.json();

// 🔹 Tüm ürünleri TEK SEFER çek
const allItemRes = await fetch(`${API_BASE}/extra-items`, {
  headers: { Authorization: `Bearer ${token}` }
});
const allItemJson = await allItemRes.json();

const result = [];

for (const sec of secJson.data || []) {
  const cats = allCatJson.data.filter(c => c.section_id === sec.id);

  for (const cat of cats) {
const menuLangs =
  JSON.parse(localStorage.getItem("menu_langs")) || ["tr"];
const menuLang = menuLangs[0];


const items = allItemJson.data
  .filter(i => i.category_id === cat.id)
  .map(i => ({
    id: i.id,
    name:
      i[`title_${menuLang}`] ||
      i.title_tr ||
      "",
    description:
      i[`description_${menuLang}`] ||
      i.description_tr ||
      "",
    price: i.price,
    currency: i.currency,
    image: i.image,
    allergens: JSON.parse(i.allergens || "[]"),
 // ⭐ EKLENDİ
    is_trend: i.is_trend === true
  }));



    result.push({
  id: sec.id,
  key: sec.category_key,   // ✅ TEK DOĞRU
  name: sec.title_tr,      // fallback
  items,
  draft: {
    title: { tr: "", en: "", de: "" },
    description: { tr: "", en: "", de: "" },
    price: "",
    currency: "TRY",
    image: "",
    allergens: []
  }
});

  }
}

  setMenuCategories(result);
};






// Extra (Menü / Kafe vb.)
const [enableMenu, setEnableMenu] = useState(false);
const [enableAllergens, setEnableAllergens] = useState(false);

  /* UI dili */
  const [uiLang, setUiLang] = useState(localStorage.getItem("app_lang") || localStorage.getItem("lang") || "tr");
  const TT = t[uiLang] || t.tr;

  /* Varsayılan içerik dili & aktif diller */
  const [contentLang, setContentLang] = useState("tr");
  const [activeContentLangs, setActiveContentLangs] = useState(["tr"]);
  const toggleActiveLang = (code) => setActiveContentLangs((prev) => (prev.includes(code) ? prev.filter((x) => x !== code) : [...prev, code]));

  /* Dil-özel metinler */
  const [firmaAdiByLang, setFirmaAdiByLang] = useState({ tr: "", en: "", de: "" });
  const [sloganByLang, setSloganByLang] = useState({ tr: "", en: "", de: "" });

  /* Diğer alanlar */
  const [subeAdi, setSubeAdi] = useState("");
  const [telefon, setTelefon] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [il, setIl] = useState("");
  const [ilce, setIlce] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [twitter, setTwitter] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [youtube, setYoutube] = useState("");
  const [tema, setTema] = useState("light");

  /* === LOGO (Etkinlikler ile aynı: URL string) === */
  const [logo, setLogo] = useState("");
  const [logoVer, setLogoVer] = useState(0);
  const buildLogoPreview = (u) => {
    const fixed = normalizeUploadUrl(u || "");
    if (!fixed) return "";
    const abs = fixed.startsWith("http") ? fixed : new URL(fixed, originWithoutPanel(ORIGIN)).href;
    return `${abs}${abs.includes("?") ? "&" : "?"}v=${logoVer}`;
  };
  const previewUrl = logo ? buildLogoPreview(logo) : "";

  const [isSaving, setIsSaving] = useState(false);
  const [newAuthorized, setNewAuthorized] = useState("");

  const defaultLangOptions = useMemo(() => LANGS.filter((l) => activeContentLangs.includes(l.code)), [activeContentLangs]);

  /* Ayarları oku */
  const loadSettings = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const { res } = await apiGetSettings(token);
      if (!res.ok) return;

      const json = await res.json();
      const d = json?.data;
      if (!d) return;

if (Array.isArray(d.aktif_diller) && d.aktif_diller.length > 0) {
  setActiveContentLangs(d.aktif_diller);

  // 🔥 contentLang AKTİF DİLLERE GÖRE BELİRLENİR
  if (d.dil && d.aktif_diller.includes(d.dil)) {
    setContentLang(d.dil);
  } else {
    setContentLang("tr");
  }
} else {
  setActiveContentLangs(["tr"]);
  setContentLang("tr");
}


      setFirmaAdiByLang({ tr: d.firma_adi_tr || "", en: d.firma_adi_en || "", de: d.firma_adi_de || "" });
      setSloganByLang({ tr: d.slogan_tr || "", en: d.slogan_en || "", de: d.slogan_de || "" });

      setSubeAdi(d.sube_adi || "");
      setNewAuthorized(d.yetkili_adi || "");
      setIl(d.il || "");
      setIlce(d.ilce || "");
      setTelefon(d.telefon || "");
      setEmail(d.email || "");
      setWebsite(d.website || "");
      setFacebook(d.facebook || "");
      setInstagram(d.instagram || "");
      setTwitter(d.twitter || "");
      setLinkedin(d.linkedin || "");
      setYoutube(d.youtube || "");
      setTema(d.tema || "light");
setEnableMenu(
  d.menu_enabled === true || d.menu_enabled === "true"
);

setEnableAllergens(
  d.allergen_enabled === true || d.allergen_enabled === "true"
);
setEnableMemorial(
  d.memorial_enabled === true || d.memorial_enabled === "true"
);

setEnableBeauty(
  d.beauty_enabled === true ||
  d.beauty_enabled === "true" ||
  d.beaty_enabled === true ||
  d.beaty_enabled === "true"
);


      setLogo(normalizeUploadUrl(d.logo_url || d.logo || ""));
      setLogoVer((n) => n + 1);

// 📎 DOSYA & LINK PAYLAŞIMLARI
if (Array.isArray(d.downloads)) {
  setDownloads(d.downloads);
} else {

  setDownloads([]);
}

// 📦 Sipariş takibi ayarı kaydet
await fetch(`${API_BASE}/menu/settings`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify({
    siparis_takibi_aktif: enableOrderTracking === true,
  }),
});

localStorage.setItem(
  "orderTrackingEnabled",
  enableOrderTracking ? "true" : "false"
);

// 🔥 MUHASEBE AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const accRes = await fetch(`${API_BASE}/accounting/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (accRes.ok) {
    const accJson = await accRes.json();
    setEnableAccounting(
      accJson?.data?.accounting_aktif === true
    );
  }
} catch (e) {
  console.error("Muhasebe ayarı okunamadı", e);
}

// 🔥 DİJİTAL İMZA AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const signatureRes = await fetch(`${API_BASE}/dijitalimza/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (signatureRes.ok) {
    const signatureJson = await signatureRes.json();
    setEnableDigitalSignature(
      signatureJson?.data?.dijital_imza_aktif === true
    );
  }
} catch (e) {
  console.error("Dijital imza ayarı okunamadı", e);
}



// 🔥 RANDEVU AYARINI AYRI ENDPOINT'TEN ÇEK
try {
  const bookingRes = await fetch(`${API_BASE}/randevu/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (bookingRes.ok) {
    const bookingJson = await bookingRes.json();
    setEnableBooking(
      bookingJson?.data?.randevu_aktif === true
    );
  }
} catch (e) {
  console.error("Randevu ayarı okunamadı", e);
}

// Pazar yeri görünürlük
setMarketplaceVisibility(d.marketplace_visibility || "all");

// 🔐 Kullanıcı & yetki yönetimi
// Şimdilik mevcut ayarlar endpoint'ini bozmamak için localStorage destekli.
// Backend hazır olunca burası /panel-users gibi gerçek endpoint'e bağlanacak.
try {
  const savedAuthUsers =
    Array.isArray(d.permission_users)
      ? d.permission_users
      : JSON.parse(localStorage.getItem("permission_users") || "[]");

  if (Array.isArray(savedAuthUsers)) {
    setAuthUsers(savedAuthUsers);
  }
} catch {
  setAuthUsers([]);
}





    } catch (e) {
      console.error("GET settings hata:", e);
    }
  };

useEffect(() => {
  loadSettings();
  loadMenuFromBackend(); // 👈 BU KRİTİK
}, []);

  const handleSave = async () => {
localStorage.setItem("content_lang", contentLang);


    if (isSaving) return;
    setIsSaving(true);
    const token = localStorage.getItem("token");

    // UI dilini kalıcı yap
    localStorage.setItem("app_lang", uiLang);
    localStorage.setItem("lang", uiLang);
    window.dispatchEvent(new Event("app_lang_change"));

    // Çok dilliler – aktif olmayanlar boş string
    const multilanguagePayload = {};
    LANGS.forEach(({ code }) => {
      const active = activeContentLangs.includes(code);
      multilanguagePayload[`firma_adi_${code}`] = active ? (firmaAdiByLang[code] || "").trim() : "";
      multilanguagePayload[`slogan_${code}`] = active ? (sloganByLang[code] || "").trim() : "";
    });

    const normalizedLogo = normalizeUploadUrl(logo);


// 🧹 BOŞ DOSYA / LINK KARTLARINI TEMİZLE
const cleanedDownloads = downloads.filter(d =>
  d.file ||
  d.link ||
  d.title?.tr ||
  d.title?.en ||
  d.title?.de
);

// 🔐 Yetkilendirme kullanıcılarını güvenli saklama
// Dikkat: Şifre düz metin kaydedilmez.
// Gerçek kullanıcı girişi için backend tarafında hash'li kullanıcı tablosu yapılacak.
const cleanedAuthUsers = authUsers.map(user => ({
  id: user.id,
  name: user.name,
  username: user.username,
  role: user.role,
  active: user.active === true,
  branchScope: user.branchScope || "all",
  branchName: user.branchName || "",
  notes: user.notes || "",
  permissions: {
    ...makePermissionMap(),
    ...(user.permissions || {}),
  },
  password_set: user.password_set === true,
  updated_at: user.updated_at || new Date().toISOString(),
}));

localStorage.setItem("permission_users", JSON.stringify(cleanedAuthUsers));

    const body = {
      ...multilanguagePayload,
    aktif_diller: activeContentLangs.length ? activeContentLangs : ["tr"],
dil: contentLang || "tr",
panel_dili: uiLang || "tr",
// menu_langs artık MenuYonetimiPage.js içinde yönetiliyor

      sube_adi: subeAdi || "",
      yetkili_adi: newAuthorized || "",
      il: il || "",
      ilce: ilce || "",
      telefon: telefon || "",
      email: email || "",
      website: website || "",
      facebook: facebook || "",
      instagram: instagram || "",
      twitter: twitter || "",
      linkedin: linkedin || "",
      youtube: youtube || "",
      tema: tema || "light",
      // Duyurular/Etkinlikler formatına paralel: düz URL string
      logo: normalizedLogo,
      // uyumluluk için ikinci anahtar
      logo_url: normalizedLogo,
 menu_enabled: enableMenu,
  allergen_enabled: enableAllergens,

   // 📅 Randevu Sistemi
booking_enabled: enableBooking === true,

// 🧾 Muhasebe / Vergi / Sigorta
accounting_enabled: enableAccounting === true,
memorial_enabled: enableMemorial === true,
cemetery_enabled: enableMemorial === true,  // ✅ cemetery.js için

beauty_enabled: enableBeauty === true,
beaty_enabled: enableBeauty === true,

  marketplace_visibility: marketplaceVisibility,

  // 🔐 Kullanıcı & Yetkilendirme
  permission_users: cleanedAuthUsers,

  menu: menuCategories,
  downloads: cleanedDownloads,
    };


    try {
      const res = await saveSettingsJson(token, body);

try { await res.clone().json(); } catch {}


// 📦 Sipariş takibi ayarı kaydet
await fetch(`${API_BASE}/menu/settings`, {
  method: "PUT",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  },
  body: JSON.stringify({
    siparis_takibi_aktif: enableOrderTracking === true,
  }),
});

localStorage.setItem(
  "orderTrackingEnabled",
  enableOrderTracking ? "true" : "false"
);


localStorage.setItem("app_institution_by_lang", JSON.stringify(firmaAdiByLang));
localStorage.setItem("panel_dili", uiLang || "tr");
localStorage.setItem("app_lang", uiLang || "tr");
localStorage.setItem("lang", uiLang || "tr");

window.dispatchEvent(new Event("app_lang_change"));
window.dispatchEvent(new Event("app_settings_change"));



      localStorage.setItem("app_institution_name", firmaAdiByLang[uiLang] || firmaAdiByLang[contentLang] || firmaAdiByLang.tr || "");
      localStorage.setItem("app_authorized_name", newAuthorized || "");
      localStorage.setItem("app_logo_url", normalizedLogo || "/logo192.png");
      window.dispatchEvent(new Event("app_settings_change"));

alert(res.ok ? TT.success : TT.fail);

if (res.ok) {
  // 🔒 STATE SNAPSHOT (kritik)
  const snapshotMenu = JSON.parse(JSON.stringify(menuCategories));

  /* ============================
     📅 RANDEVU AYARINI KAYDET
     ============================ */
  try {
    await fetch(`${API_BASE}/randevu/settings`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        randevu_aktif: enableBooking === true,
      }),
    });

} catch (e) {
    console.error("Randevu ayarı kaydedilemedi", e);
  }

/* ============================
   📦 SİPARİŞ TAKİBİ AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/menu/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      siparis_takibi_aktif: enableOrderTracking === true,
    }),
  });
  console.log("✅ Sipariş takibi ayarı kaydedildi:", enableOrderTracking);
} catch (e) {
  console.error("❌ Sipariş takibi ayarı kaydedilemedi", e);
}

/* ============================
   🧾 MUHASEBE AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/accounting/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      accounting_aktif: enableAccounting === true,
    }),
  });
} catch (e) {
  console.error("Muhasebe ayarı kaydedilemedi", e);
}


/* ============================
   📄 DİJİTAL İMZA AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/dijitalimza/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      dijital_imza_aktif: enableDigitalSignature === true,
    }),
  });
  console.log("✅ Dijital imza ayarı kaydedildi");
} catch (e) {
  console.error("❌ Dijital imza ayarı kaydedilemedi", e);
}


/* ============================
   🪦 MEZARLIK AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/cemetery/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      cemetery_enabled: enableMemorial === true,
      allow_public_condolences: true,
      require_approval: false,
      allow_public_gallery: true,
    }),
  });
  console.log("✅ Mezarlık ayarı kaydedildi:", enableMemorial);
} catch (e) {
  console.error("❌ Mezarlık ayarı kaydedilemedi", e);
}

/* ============================
   💇‍♀️ KUAFÖR / GÜZELLİK AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/beaty/settings`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      beauty_enabled: enableBeauty === true,
      beaty_enabled: enableBeauty === true,
    }),
  });

  console.log("✅ Kuaför / Güzellik ayarı kaydedildi:", enableBeauty);
} catch (e) {
  console.error("❌ Kuaför / Güzellik ayarı kaydedilemedi", e);
}


/* ============================
   🏬 PAZAR YERİ GÖRÜNÜRLÜK AYARINI KAYDET
   ============================ */
try {
  await fetch(`${API_BASE}/market/visibility`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      visibility: marketplaceVisibility,
    }),
  });
  console.log("✅ Pazar yeri görünürlük kaydedildi:", marketplaceVisibility);
} catch (e) {
  console.error("❌ Pazar yeri görünürlük kaydedilemedi", e);
}

  // await saveMenuToBackend(snapshotMenu);
  // await loadMenuFromBackend(); // 👈 geri gelince dolu görünsün
  loadSettings();

  // 🔔 Sidebar / Menü anında güncellensin
  window.dispatchEvent(new Event("app_settings_change"));
}



} catch (err) {
  console.error(err);
  alert(TT.serverError);
} finally {
  setIsSaving(false);
}



  };
  // 🔐 ŞİFRE DEĞİŞTİR
  const handleChangePassword = async () => {
    if (passLoading) return;

    if (!currentPassword || !newPassword || !newPassword2) {
alert(TT.fillAllFields);
      return;
    }

    if (newPassword !== newPassword2) {
alert(TT.passwordsNotMatch);
      return;
    }

    if (newPassword.length < 6) {
alert(TT.passwordMin);
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
alert(TT.sessionNotFound);
      return;
    }

    setPassLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          currentPassword,
          newPassword,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Şifre değiştirilemedi");
        return;
      }

alert(TT.passwordUpdated);

      setCurrentPassword("");
      setNewPassword("");
      setNewPassword2("");
      setOpenPass(false);

    } catch (e) {
alert(TT.serverError);
    } finally {
      setPassLoading(false);
    }
  };


  return (
  <div className="w-full min-h-screen bg-[#F7F8FA]">
  <div className="w-full px-3 md:px-6 lg:px-8 py-4">

        {/* Başlık + UI dili */}
        <div className="flex items-center gap-4 mb-8">
          <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900">{TT.settings}</h1>
          <div className="flex items-center gap-3">
            <span className="text-base text-gray-800 font-medium">{TT.uiLanguage}</span>
            <Segmented
              value={uiLang}
            onChange={(code) => {
  setUiLang(code);
  localStorage.setItem("panel_dili", code);
  localStorage.setItem("app_lang", code);
  localStorage.setItem("lang", code);
  window.dispatchEvent(new Event("app_lang_change"));
  window.dispatchEvent(new Event("app_settings_change"));
                try {
                  const map = JSON.parse(localStorage.getItem("app_institution_by_lang") || "{}");
                  if (map && typeof map === "object") {
                    localStorage.setItem("app_institution_name", map[code] || map.tr || "");
                    window.dispatchEvent(new Event("app_settings_change"));
                  }
                } catch {}
              }}
            />
          </div>
        </div>

        {/* İçerik dilleri */}
        <div className="mb-8 p-5 bg-white rounded-2xl shadow border border-gray-100">
          <div className="flex flex-col gap-4">
            <div className="text-xl md:text-2xl font-bold text-gray-900">{TT.contentLanguage}</div>
            <div className="flex flex-wrap gap-2">
              {LANGS.map((l) => {
                const active = activeContentLangs.includes(l.code);
                return (
                  <button
                    key={l.code}
                    type="button"
                    onClick={() => toggleActiveLang(l.code)}
                    className={[
                      "px-3 py-1.5 rounded-full text-sm border transition font-medium",
                      active ? "bg-blue-600 text-white border-blue-600" : "bg-white text-blue-700 border-blue-600 hover:bg-blue-50",
                    ].join(" ")}
                  >
                    {l.label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Dil-özel metinler */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.firmName}</label>
              <input
                type="text"
                value={firmaAdiByLang[contentLang]}
                onChange={(e) => setFirmaAdiByLang((p) => ({ ...p, [contentLang]: e.target.value }))}
                className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900"
                placeholder={TT.firmName}
              />
            </div>
            <div>
              <label className="block text-[19px] font-semibold text-gray-900">{TT.slogan}</label>
              <input
                type="text"
                value={sloganByLang[contentLang]}
                onChange={(e) => setSloganByLang((p) => ({ ...p, [contentLang]: e.target.value }))}
                className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900"
                placeholder={TT.slogan}
              />
            </div>
          </div>

          {/* Dil-dışı alanlar */}
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.branch}</label>
              <input type="text" value={subeAdi} onChange={(e) => setSubeAdi(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
            </div>

            <div className="mb-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.authorizedEditable}</label>
              <input type="text" value={newAuthorized} onChange={(e) => setNewAuthorized(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" placeholder={TT.authorizedEditable} />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.city}</label>
                <input type="text" value={il} onChange={(e) => setIl(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.district}</label>
                <input type="text" value={ilce} onChange={(e) => setIlce(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.phone}</label>
                <input type="tel" value={telefon} onChange={(e) => setTelefon(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
              <div>
                <label className="block text-[19px] font-semibold text-gray-900">{TT.email}</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
              </div>
            </div>

            <div className="mt-4">
              <label className="block text-[19px] font-semibold text-gray-900">{TT.website}</label>
              <input type="url" value={website} onChange={(e) => setWebsite(e.target.value)} className="w-full p-3 border rounded-xl mt-1 text-base text-gray-900" />
            </div>
          </div>






          {/* Logo alanı — Etkinlikler formatı */}
          <div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
            <label className="block text-[19px] font-semibold text-gray-900 mb-2">{TT.logoUpload}</label>
            <div style={{ display: "grid", gridTemplateColumns: "96px 1fr", gap: 12, alignItems: "center" }}>
              <div>
                {logo ? (
                  <img key={previewUrl} src={previewUrl} alt="Logo" style={{ width: 88, height: 88, objectFit: "cover", borderRadius: 10, border: "1px solid #e5e7eb" }} />
                ) : (
                  <div style={{ width: 88, height: 88, borderRadius: 10, border: "1px dashed #cbd5e1", display: "grid", placeItems: "center", color: "#94a3b8", fontSize: 20 }}>🖼️</div>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: 8 }}>
                <input
                  value={logo || ""}
                  onChange={(e) => setLogo(e.target.value)}
                  onBlur={(e) => { setLogo(normalizeUploadUrl(e.target.value)); setLogoVer((n) => n + 1); }}
                  className="w-full p-3 border rounded-xl mt-0 text-base text-gray-900"
                  placeholder="https://... (logo URL)"
                />
                <ResimUpload
                  label={TT.logoUpload}
                  onUpload={(url) => {
                    const fixed = normalizeUploadUrl(url);
                    setLogo(fixed);
                    setLogoVer((n) => n + 1);
                    localStorage.setItem("app_logo_url", fixed);
                    window.dispatchEvent(new Event("app_settings_change"));
                  }}
                  defaultPreview={previewUrl || undefined}
                />
              </div>
            </div>
          </div>
          {/* /Logo alanı */}








{/* ================= MENÜ / HİZMET AYARLARI ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    🍽️ {TT.menuSettings}
  </h2>

  {/* Menü aktif mi */}
  <div className="flex items-center justify-between mb-4">
    <div>
     <div className="font-semibold text-gray-900 text-base">
  {TT.menuEnableTitle}
</div>
      <div className="text-sm text-gray-500">
        {TT.menuEnableDesc}
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableMenu}
      onChange={(e) => setEnableMenu(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>

  {/* Alerji bilgileri */}
  {enableMenu && (
    <div className="flex items-center justify-between">
      <div>
       <div className="font-semibold text-gray-900 text-base">
  {TT.allergenTitle}
</div>
        <div className="text-sm text-gray-500">
          {TT.allergenDesc}
        </div>
      </div>

      <input
        type="checkbox"
        checked={enableAllergens}
        onChange={(e) => setEnableAllergens(e.target.checked)}
        className="w-5 h-5 accent-orange-600"
      />
    </div>
  )}
</div>

 


{/* ================= SİPARİŞ TAKİBİ ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
📦 {TT.orderTitle}
  </h2>
  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
{TT.orderEnable}
      </div>
      <div className="text-sm text-gray-500">
{TT.orderDesc}
      </div>
    </div>
    <input
      type="checkbox"
      checked={enableOrderTracking}
      onChange={(e) => setEnableOrderTracking(e.target.checked)}
      className="w-6 h-6 accent-orange-600"
    />
  </div>
</div>

{/* ================= QR MEZARLIK / DİJİTAL ANIT ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
🪦 {TT.memorialTitle}
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
{TT.memorialEnable}
      </div>
      <div className="text-sm text-gray-500">
{TT.memorialDesc}
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableMemorial}
      onChange={(e) => setEnableMemorial(e.target.checked)}
      className="w-6 h-6 accent-orange-600"
    />
  </div>
</div>

{/* ================= KUAFÖR / GÜZELLİK SALONU ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    💇‍♀️ {TT.beautyTitle}
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
        {TT.beautyEnable}
      </div>

      <div className="text-sm text-gray-500">
        {TT.beautyDesc}
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableBeauty}
      onChange={(e) => setEnableBeauty(e.target.checked)}
      className="w-6 h-6 accent-orange-600"
    />
  </div>
</div>

{/* ================= RANDEVU SİSTEMİ ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
📅 {TT.bookingTitle}
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-900">
{TT.bookingEnable}
      </div>
      <div className="text-sm text-gray-500">
{TT.bookingDesc}
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableBooking}
      onChange={(e) => setEnableBooking(e.target.checked)}
className="w-6 h-6 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />


{/* ================= MUHASEBE / VERGİ / SİGORTA ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
🧾 {TT.accountingTitle}
  </h2>

  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
🧾 {TT.accountingTitle}
      </div>
      <div className="text-sm text-gray-500">
        Evrak toplama, vergi beyanı ve sigorta işlemleri
      </div>
    </div>

    <input
      type="checkbox"
      checked={enableAccounting}
      onChange={(e) => setEnableAccounting(e.target.checked)}
className="w-6 h-6 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />

{/* ================= DİJİTAL İMZA SİSTEMİ ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    📄 Dijital Evrak & İmza
  </h2>
  <div className="flex items-center justify-between">
    <div>
      <div className="font-semibold text-gray-800">
        Dijital İmza Sistemini Aktif Et
      </div>
      <div className="text-sm text-gray-500">
        PDF evrak gönderimi, mobil imza, imzalı PDF takibi
      </div>
    </div>
    <input
      type="checkbox"
      checked={enableDigitalSignature}
      onChange={(e) => setEnableDigitalSignature(e.target.checked)}
      className="w-5 h-5 accent-orange-600"
    />
  </div>
</div>

{/* 🔶 AYIRICI – sadece görsel */}
<hr className="my-8 border-t-2 border-orange-200" />


{/* ================= 📎 DOSYA & LINK PAYLAŞIMLARI ================= */}
<div className="mt-6 w-full bg-white rounded-2xl shadow border border-gray-200 p-4 md:p-6">

 <h2 className="text-2xl font-bold p-6 border-b">
  📎 {TT.downloadsTitle}
</h2>

 

  {/* ================= EKLE / GÜNCELLE FORMU (EN ALT) ================= */}
  <div className="border-t p-6 bg-gray-50 space-y-3">

    <h3 className="text-lg font-bold">
     {editingDownloadId ? `✏️ ${TT.downloadEdit}` : `➕ ${TT.downloadAdd}`}

    </h3>

<input
  className="w-full p-3 border rounded-xl"
placeholder={TT.title}
  value={downloadDraft.title[contentLang] || ""}
  onChange={e =>
    setDownloadDraft({
      ...downloadDraft,
      title: {
        ...downloadDraft.title,
        [contentLang]: e.target.value
      }
    })
  }
/>


    <textarea
  className="w-full p-3 border rounded-xl"
placeholder={TT.description}
  value={downloadDraft.description[contentLang] || ""}
  onChange={e =>
    setDownloadDraft({
      ...downloadDraft,
      description: {
        ...downloadDraft.description,
        [contentLang]: e.target.value
      }
    })
  }
/>


    <ResimUpload
  label={TT.uploadFile}
  mode="all"
  onUpload={url =>
    setDownloadDraft({
      ...downloadDraft,
      file: normalizeUploadUrl(url)
    })
  }
/>


    {downloadDraft.file && (
      <div className="text-sm text-green-700 break-all">
        📄 {downloadDraft.file}
      </div>
    )}

    <input
      className="w-full p-3 border rounded-xl"
      placeholder="https://..."
      value={downloadDraft.link}
      onChange={e =>
        setDownloadDraft({ ...downloadDraft, link: e.target.value })
      }
    />

    <button
      className="w-full bg-green-600 text-white py-3 rounded-xl font-semibold"
      onClick={() => {
    if (
  !downloadDraft.title.tr &&
  !downloadDraft.title.en &&
  !downloadDraft.title.de &&
  !downloadDraft.file &&
  !downloadDraft.link
) return;


        if (editingDownloadId) {
          // GÜNCELLE
        setDownloads(downloads.map(d =>
  d.id === editingDownloadId
    ? {
        ...d,
        title: {
          ...d.title,
          ...downloadDraft.title
        },
        description: {
          ...d.description,
          ...downloadDraft.description
        },
        file: downloadDraft.file,
        link: downloadDraft.link
      }
    : d
));



        } else {
          // EKLE
          setDownloads([
            ...downloads,
            {
              id: Date.now(),
            title: { ...downloadDraft.title },
description: { ...downloadDraft.description },

              file: downloadDraft.file,
              link: downloadDraft.link
            }
          ]);
        }

        // RESET
      setDownloadDraft({
  title: { tr:"", en:"", de:"" },
  description: { tr:"", en:"", de:"" },
  file: "",
  link: ""
});

        setEditingDownloadId(null);
      }}
    >
{editingDownloadId ? `💾 ${TT.update}` : `➕ ${TT.add}`}
    </button>
  </div>


{/* ================= LİSTE ================= */}
<div className="space-y-4 p-6">

  {downloads.length === 0 && (
    <div className="text-gray-500 text-sm">
{TT.noDownloads}
    </div>
  )}

  {downloads.map((item, index) => (
    <div key={item.id} className="bg-gray-50 border rounded-xl p-4">
      <div className="flex justify-between items-start gap-4">
        <div className="flex-1">
          <div className="font-bold text-lg">
{item.title?.[contentLang] || item.title?.tr
 || TT.unnamed}
          </div>

          {item.description?.[contentLang] && (
            <div className="text-sm text-gray-600 mt-1">
              {item.description[contentLang]}
            </div>
          )}

          {item.file && (
            <a
              href={item.file}
              target="_blank"
              rel="noreferrer"
              className="block mt-2 text-green-700 text-sm break-all"
            >
              📄 {TT.file}
            </a>
          )}

          {item.link && (
            <a
              href={item.link}
              target="_blank"
              rel="noreferrer"
              className="block mt-1 text-blue-700 text-sm break-all"
            >
              🔗{TT.link}
            </a>
          )}
        </div>

        <div className="flex gap-3">
          <button
            className="text-orange-600 font-semibold"
            onClick={() => {
              setEditingDownloadId(item.id);
             setDownloadDraft({
  title: item.title || { tr:"", en:"", de:"" },
  description: item.description || { tr:"", en:"", de:"" },
  file: item.file || "",
  link: item.link || ""
});

            }}
          >
            ✏️ {TT.edit}
          </button>

          <button
            className="text-red-600 font-semibold"
            onClick={() =>
              setDownloads(downloads.filter((_, i) => i !== index))
            }
          >
            🗑{TT.delete}
          </button>
        </div>
      </div>
    </div>
  ))}
</div>

</div>




{/* ================= PAZAR YERİ GÖRÜNÜRLÜK ================= */}
<div className="p-5 bg-white rounded-2xl shadow border border-gray-100 mt-6">
  <h2 className="text-xl font-bold text-gray-900 mb-4">
    🏬 {TT.marketplaceVisibility}
  </h2>

  <div className="space-y-4">
    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-all"
        name="marketplaceVisibility"
        value="all"
        checked={marketplaceVisibility === "all"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-all" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceAll}</span>
        <p className="text-sm text-gray-500">{TT.marketplaceVisibilityDesc} - {TT.marketplaceAll}</p>
      </label>
    </div>

    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-sector"
        name="marketplaceVisibility"
        value="sector"
        checked={marketplaceVisibility === "sector"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-sector" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceOwnSector}</span>
        <p className="text-sm text-gray-500">Sadece kendi sektörüm dışındaki kurumlar görünsün</p>
      </label>
    </div>

    <div className="flex items-center gap-4">
      <input
        type="radio"
        id="marketplace-none"
        name="marketplaceVisibility"
        value="none"
        checked={marketplaceVisibility === "none"}
        onChange={(e) => setMarketplaceVisibility(e.target.value)}
        className="w-5 h-5 accent-orange-600"
      />
      <label htmlFor="marketplace-none" className="text-gray-800">
        <span className="font-semibold">{TT.marketplaceNone}</span>
        <p className="text-sm text-gray-500">{TT.marketplaceVisibilityDesc} - {TT.marketplaceNone}</p>
      </label>
    </div>
  </div>
</div>



{/* ================= 🔐 ŞİFRE DEĞİŞTİR ================= */}
<div className="md:col-span-2 mt-10 bg-white rounded-2xl shadow border border-gray-200 overflow-hidden">
  <button
    type="button"
    onClick={() => setOpenPass(!openPass)}
    className="w-full flex items-center justify-between px-6 py-4 hover:bg-gray-50"
  >
    <div>
      <div className="text-lg font-extrabold text-gray-900">
        {TT.passwordChangeTitle}
      </div>
      <div className="text-sm text-gray-500">
        {TT.passwordChangeDesc}
      </div>
    </div>
    <div className="text-2xl text-gray-500">
      {openPass ? "−" : "+"}
    </div>
  </button>

  {openPass && (
    <div className="px-6 pb-6 pt-2 border-t bg-gray-50 space-y-4">
      <input
        type="password"
        placeholder={TT.currentPassword}
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <input
        type="password"
        placeholder={TT.newPassword}
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <input
        type="password"
        placeholder={TT.newPasswordRepeat}
        value={newPassword2}
        onChange={(e) => setNewPassword2(e.target.value)}
        className="w-full p-3 border rounded-xl"
      />

      <button
        onClick={handleChangePassword}
        disabled={passLoading}
        className={`w-full py-3 rounded-xl font-semibold text-white ${
          passLoading ? "bg-gray-400" : "bg-red-600 hover:bg-red-700"
        }`}
      >
        {passLoading ? "⏳" : "🔐"} {TT.updatePassword}
      </button>
    </div>
  )}
</div>




{/* ================= 🔐 KULLANICI & YETKİLENDİRME ================= */}
<div className="md:col-span-2 mt-10 bg-white rounded-2xl shadow border border-gray-200 overflow-hidden">
  <button
    type="button"
    onClick={() => setOpenAuthorization(!openAuthorization)}
    className="w-full flex items-center justify-between px-6 py-5 hover:bg-gray-50"
  >
    <div>
      <div className="text-xl font-extrabold text-gray-900">
        🔐 Kullanıcılar & Yetkilendirme
      </div>
      <div className="text-sm text-gray-500 mt-1">
        Garson, kasiyer, müdür, stok sorumlusu veya özel kullanıcı oluşturun. Her modül tek tek açılıp kapatılabilir.
      </div>
    </div>

    <div className="text-2xl text-gray-500">
      {openAuthorization ? "−" : "+"}
    </div>
  </button>

  {openAuthorization && (
    <div className="border-t bg-gray-50 p-4 md:p-6 space-y-6">

      {/* BİLGİ KUTUSU */}
      <div className="rounded-2xl border border-orange-200 bg-orange-50 p-4">
        <div className="font-extrabold text-orange-900">
          Kurumsal yetki mantığı
        </div>
        <div className="text-sm text-orange-800 mt-1 leading-6">
          İlk verilen ana kullanıcı tam yetkilidir. Firma sahibi buradan personel kullanıcıları oluşturur.
          Garson kasayı göremez, stok sorumlusu sadece stokları görebilir, müdür ise seçilen modüllere erişebilir.
          Gerçek güvenlik için sonraki adımda backend login ve API yetki kontrolü bağlanacaktır.
        </div>
      </div>

      {/* FORM */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
        <div className="xl:col-span-1 bg-white rounded-2xl border shadow-sm p-4 md:p-5 space-y-4">
          <div>
            <div className="text-lg font-extrabold text-gray-900">
              {editingAuthId ? "✏️ Kullanıcı Düzenle" : "➕ Yeni Kullanıcı"}
            </div>
            <div className="text-sm text-gray-500">
              Personel için kullanıcı adı, geçici şifre, rol ve şube kapsamı belirleyin.
            </div>
          </div>

          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1">
              Ad Soyad
            </label>
            <input
              value={authDraft.name}
              onChange={(e) => setAuthDraft(prev => ({ ...prev, name: e.target.value }))}
              className="w-full p-3 border rounded-xl text-gray-900"
              placeholder="Örn: Ahmet Garson"
            />
          </div>

          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1">
              Kullanıcı Adı
            </label>
            <input
              value={authDraft.username}
              onChange={(e) => setAuthDraft(prev => ({ ...prev, username: e.target.value }))}
              className="w-full p-3 border rounded-xl text-gray-900"
              placeholder="Örn: ahmet.garson"
            />
          </div>

          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1">
              {editingAuthId ? "Yeni Şifre (isteğe bağlı)" : "Geçici Şifre"}
            </label>
            <input
              type="password"
              value={authDraft.password}
              onChange={(e) => setAuthDraft(prev => ({ ...prev, password: e.target.value }))}
              className="w-full p-3 border rounded-xl text-gray-900"
              placeholder={editingAuthId ? "Boş bırakılırsa değişmez" : "Personelin ilk şifresi"}
            />
            <div className="text-xs text-gray-500 mt-1">
              Şifre ayarlar içinde düz metin saklanmaz. Backend bağlanınca güvenli şekilde hash'lenecek.
            </div>
          </div>

          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1">
              Rol
            </label>
            <select
              value={authDraft.role}
              onChange={(e) => handleAuthRoleChange(e.target.value)}
              className="w-full p-3 border rounded-xl text-gray-900 bg-white"
            >
              {Object.entries(ROLE_PRESETS).map(([key, role]) => (
                <option key={key} value={key}>
                  {role.label}
                </option>
              ))}
            </select>

            <div className="text-xs text-gray-500 mt-1">
              {ROLE_PRESETS[authDraft.role]?.desc || ROLE_PRESETS.custom.desc}
            </div>
          </div>

          <div>
            <label className="block text-sm font-bold text-gray-800 mb-1">
              Şube Yetkisi
            </label>
            <select
              value={authDraft.branchScope}
              onChange={(e) => setAuthDraft(prev => ({ ...prev, branchScope: e.target.value }))}
              className="w-full p-3 border rounded-xl text-gray-900 bg-white"
            >
              <option value="all">Tüm şubeler</option>
              <option value="single">Sadece seçili şube</option>
              <option value="custom">Özel şube kapsamı</option>
            </select>
          </div>

          {authDraft.branchScope !== "all" && (
            <div>
              <label className="block text-sm font-bold text-gray-800 mb-1">
                Şube Adı / Kapsam Notu
              </label>
              <input
                value={authDraft.branchName}
                onChange={(e) => setAuthDraft(prev => ({ ...prev, branchName: e.target.value }))}
                className="w-full p-3 border rounded-xl text-gray-900"
                placeholder="Örn: Merkez Şube"
              />
            </div>
          )}

          <div className="flex items-center justify-between rounded-xl border p-3 bg-gray-50">
            <div>
              <div className="font-bold text-gray-900">Aktif Kullanıcı</div>
              <div className="text-xs text-gray-500">Pasif yapılırsa giriş yapamaz.</div>
            </div>

            <input
              type="checkbox"
              checked={authDraft.active}
              onChange={(e) => setAuthDraft(prev => ({ ...prev, active: e.target.checked }))}
              className="w-5 h-5 accent-orange-600"
            />
          </div>

          <textarea
            value={authDraft.notes}
            onChange={(e) => setAuthDraft(prev => ({ ...prev, notes: e.target.value }))}
            className="w-full p-3 border rounded-xl text-gray-900"
            placeholder="İç not: örn. Sadece akşam vardiyası"
            rows={3}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <button
              type="button"
              onClick={handleSaveAuthUser}
              className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-extrabold"
            >
              {editingAuthId ? "💾 Güncelle" : "➕ Kullanıcı Ekle"}
            </button>

            <button
              type="button"
              onClick={resetAuthDraft}
              className="w-full bg-white hover:bg-gray-50 text-gray-800 border py-3 rounded-xl font-extrabold"
            >
              Temizle
            </button>
          </div>
        </div>

        {/* YETKİLER */}
        <div className="xl:col-span-2 bg-white rounded-2xl border shadow-sm p-4 md:p-5">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-5">
            <div>
              <div className="text-lg font-extrabold text-gray-900">
                Modül Yetkileri
              </div>
              <div className="text-sm text-gray-500">
                Seçili kullanıcı hangi ekranı görsün, hangi işlemi yapabilsin?
              </div>
            </div>

            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => toggleAllAuthPermissions(true)}
                className="px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-bold text-sm"
              >
                Hepsini Seç
              </button>

              <button
                type="button"
                onClick={() => toggleAllAuthPermissions(false)}
                className="px-4 py-2 rounded-xl bg-white hover:bg-gray-50 text-gray-800 border font-bold text-sm"
              >
                Hepsini Kapat
              </button>
            </div>
          </div>

          <div className="mb-4 rounded-xl bg-blue-50 border border-blue-100 p-3 text-sm text-blue-800">
            Seçili yetki:{" "}
            <strong>
              {Object.values(authDraft.permissions || {}).filter(Boolean).length}
            </strong>
            {" / "}
            {ALL_PERMISSION_KEYS.length}
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {AUTH_PERMISSION_GROUPS.map((group) => {
              const groupKeys = group.items.map(item => item.key);
              const allChecked = groupKeys.every(key => authDraft.permissions?.[key]);
              const someChecked = groupKeys.some(key => authDraft.permissions?.[key]);

              return (
                <div
                  key={group.title}
                  className="rounded-2xl border border-gray-200 overflow-hidden"
                >
                  <div className="p-4 bg-gray-50 border-b">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <div className="font-extrabold text-gray-900">
                          {group.title}
                        </div>
                        <div className="text-xs text-gray-500 mt-1">
                          {group.desc}
                        </div>
                      </div>

                      <label className="flex items-center gap-2 text-xs font-bold text-gray-700 whitespace-nowrap">
                        <input
                          type="checkbox"
                          checked={allChecked}
                          ref={(el) => {
                            if (el) el.indeterminate = !allChecked && someChecked;
                          }}
                          onChange={(e) => toggleAuthGroup(group, e.target.checked)}
                          className="w-4 h-4 accent-orange-600"
                        />
                        Grup
                      </label>
                    </div>
                  </div>

                  <div className="p-4 space-y-3">
                    {group.items.map((item) => (
                      <label
                        key={item.key}
                        className="flex items-center justify-between gap-3 rounded-xl border p-3 hover:bg-orange-50 cursor-pointer"
                      >
                        <div>
                          <div className="font-semibold text-gray-900">
                            {item.label}
                          </div>
                          <div className="text-xs text-gray-400">
                            {item.key}
                          </div>
                        </div>

                        <input
                          type="checkbox"
                          checked={authDraft.permissions?.[item.key] === true}
                          onChange={() => toggleAuthPermission(item.key)}
                          className="w-5 h-5 accent-orange-600"
                        />
                      </label>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* KULLANICI LİSTESİ */}
      <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
        <div className="p-5 border-b">
          <div className="text-lg font-extrabold text-gray-900">
            Tanımlı Kullanıcılar
          </div>
          <div className="text-sm text-gray-500">
            Firma sahibi dışındaki personel kullanıcıları burada listelenir.
          </div>
        </div>

        {authUsers.length === 0 ? (
          <div className="p-6 text-sm text-gray-500">
            Henüz personel kullanıcısı eklenmedi.
          </div>
        ) : (
          <div className="divide-y">
            {authUsers.map((user) => {
              const selectedCount = Object.values(user.permissions || {}).filter(Boolean).length;
              const roleLabel = ROLE_PRESETS[user.role]?.label || "Özel Rol";

              return (
                <div
                  key={user.id}
                  className="p-4 md:p-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
                >
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <div className="font-extrabold text-gray-900 text-lg">
                        {user.name}
                      </div>

                      <span className={`px-2 py-1 rounded-full text-xs font-bold ${
                        user.active
                          ? "bg-green-100 text-green-700"
                          : "bg-red-100 text-red-700"
                      }`}>
                        {user.active ? "Aktif" : "Pasif"}
                      </span>
                    </div>

                    <div className="text-sm text-gray-500 mt-1">
                      Kullanıcı adı: <strong>{user.username}</strong> · Rol: <strong>{roleLabel}</strong>
                    </div>

                    <div className="text-sm text-gray-500 mt-1">
                      Şube:{" "}
                      <strong>
                        {user.branchScope === "all"
                          ? "Tüm şubeler"
                          : user.branchName || "Seçili şube"}
                      </strong>
                      {" · "}
                      Yetki: <strong>{selectedCount}</strong> / {ALL_PERMISSION_KEYS.length}
                    </div>

                    {user.notes && (
                      <div className="text-xs text-gray-400 mt-1">
                        Not: {user.notes}
                      </div>
                    )}
                  </div>

                  <div className="flex flex-wrap gap-2">
                    <button
                      type="button"
                      onClick={() => handleEditAuthUser(user)}
                      className="px-4 py-2 rounded-xl border bg-white hover:bg-gray-50 text-gray-800 font-bold"
                    >
                      ✏️ Düzenle
                    </button>

                    <button
                      type="button"
                      onClick={() =>
                        setAuthUsers(prev =>
                          prev.map(u =>
                            u.id === user.id
                              ? { ...u, active: !u.active }
                              : u
                          )
                        )
                      }
                      className="px-4 py-2 rounded-xl border bg-white hover:bg-gray-50 text-gray-800 font-bold"
                    >
                      {user.active ? "Pasif Yap" : "Aktif Yap"}
                    </button>

                    <button
                      type="button"
                      onClick={() => handleDeleteAuthUser(user.id)}
                      className="px-4 py-2 rounded-xl bg-red-600 hover:bg-red-700 text-white font-bold"
                    >
                      🗑 Sil
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

    </div>
  )}
</div>
{/* KAYDET BUTONU */}

<div className="mt-10">
  <button
    onClick={handleSave}
    disabled={isSaving}
    className={[
      "px-6 py-3 rounded-2xl text-lg font-semibold shadow",
      isSaving
        ? "bg-gray-400 text-white cursor-not-allowed"
        : "bg-orange-600 hover:bg-orange-700 text-white"
    ].join(" ")}
  >
    {isSaving ? "⏳" : "💾"} {TT.save}
  </button>
</div>


</div>
</div>
</div>
  );
}